import {createGlobalStyle} from 'styled-components'

const GlobalStyle = createGlobalStyle`
	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed, 
	figure, figcaption, footer, header, hgroup, 
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font: inherit;
		vertical-align: baseline;
	}
	article, aside, details, figcaption, figure, 
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	ol, ul {
		list-style: none;
	}
	a{
		text-decoration: none;
	}
	
	body {
		line-height: 1;
		font-family: var(--font-primary), sans-serif;
		min-height: 100vh;
	}
	main{
		min-height: calc(100vh - (146px + 82px));
		background-image: linear-gradient(
			${props => props.theme.background.gradient.light},
			${props => props.theme.background.gradient.medium},
			${props => props.theme.background.gradient.dark}
		)
	}
`

export default GlobalStyle